import * as lib from '../lib'
import { IFetchItems, IFetchOfferAffiliateNetwork } from '../types'

export const listOfferAffiliateNetwork = async (
	signal: AbortSignal,
	token?: string | null
): Promise<IFetchItems<IFetchOfferAffiliateNetwork>> => {
	const headers = lib.bearer(token)
	const method: string = 'GET'
	const params: lib.FetchOptions['params'] = {}
	const uri: string = 'offer/affiliate-network?take=all'

	const options: lib.FetchOptions = {
		headers,
		method,
		params,
		signal
	}
	const data = await lib.fetching<IFetchItems<IFetchOfferAffiliateNetwork>>(uri, options)

	return {
		items: data?.items ?? [],
		total: data?.items?.length ?? 0
	}
}